<!--
 * @Author: tkp
 * @Date: 2024-11-04 11:17:33
-->
<template>
  <el-image :style="imgStyle" :src="imageUrl" :preview-src-list="imageUrlArr" :fit="fit" @load="loadImage"></el-image>
</template>

<script>
import { generatePresignedUrl } from '@/utils/api'
export default {
  props: {
    url: {
      type: String | File,
      default: ''
    },
    hasPreview: {
      type: Boolean,
      default: false
    },
    imgStyle: {
      type: String,
      default: () => {
        return ''
      }
    },
    fit: {
      type: String,
      default: () => {
        return 'cover'
      }
    }
  },
  data() {
    return {
      imageUrl: '',
      imageUrlArr: []
    }
  },
  watch: {
    url: {
      handler() {
        this.initImage()
      },
      immediate: true
    }
  },
  mounted() {
    this.initImage()
  },
  methods: {
    loadImage(e) {
      this.$emit('loadImg', { width: e.target.width || 0, height: e.target.height || 0 })
    },
    initImage() {
      generatePresignedUrl({ fileUrl: this.url }).then((res) => {
        this.imageUrl = res.data || ''
        if (this.hasPreview) {
          this.imageUrlArr = [res.data]
        } else {
          this.imageUrlArr = []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/myElImage/index.vue